var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.loading
    ? _c("div", [
        _c("div", { staticClass: "info--text text-uppercase my-3 mt-2" }, [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.generateMessage("requests.details.titles.contractualData")
              ) +
              "\n  "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex pl-3" }, [
          _c(
            "div",
            [
              _c("custom-simple-table", {
                attrs: {
                  item: _vm.property.contractual_commitment,
                  "i18-path": "properties_360.fields.contractual_commitment",
                  "table-keys": [
                    "contract_reference",
                    "contract_reference_name"
                  ]
                }
              }),
              _vm._v(" "),
              _c("display-checkbox", {
                attrs: {
                  label: _vm.generateMessage(
                    "properties_360.fields.active_enabled"
                  ),
                  "input-value": _vm.property.active_enabled
                }
              }),
              _vm._v(" "),
              _c("maintenance-contract-infos")
            ],
            1
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }